/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { persistStore } from 'redux-persist'

import models from 'models'

import reducers from './reducers'

const sagaMiddleware = createSagaMiddleware()

const middlewares = compose(applyMiddleware(sagaMiddleware))

export const composedMiddlewares =
  window.__REDUX_DEVTOOLS_EXTENSION__ && (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? compose(middlewares, window.__REDUX_DEVTOOLS_EXTENSION__())
    : middlewares

const store = createStore(reducers, composedMiddlewares)
sagaMiddleware.run(models.sagas)

const persistor = persistStore(store)

export { store, persistor }
